// Идентификаторы инструментов меню
export const MenuItemsIds = {
    // мои проекты
    PROJECTS: 1,

    // групповой отчёт
    GROUP: 2,
    // сравнить сайты
    COMPARE: 3,
    // пакетный анализ
    TOOLS_DOMAINS_BATCH: 4,
    // доля конкурентов по фразе
    TOOLS_CONCURENTS_BY_KEYWORDS: 5,
    // главные темы сайта
    TOOLS_SITE_THEMES: 6,
    // список запросов страниц
    TOOLS_KEYWORDS_BY_PAGES: 7,
    // расширение словаря по странице
    TOOLS_DICTIONARY_EXT_BY_PAGE: 8,
    // словарь слов по страницам
    TOOLS_DICTIONARY_BY_PAGES: 9,
    // история robots.txt
    ROBOTS: 10,
    // автоматическое продвижение сайта
    SEO_MODULE: 37,

    // анализ ссылок
    LINKS: 11,
    // пакетный анализ по ссылкам
    LINKS_DOMAINS_BATCH: 12,
    // сравнить сайты (по ссылкам)
    COMPARE_BACKLINKS: 13,

    // база запросов
    SEARCHKEYS: 14,
    // дополняющие фразы
    SIMILARKEYS: 15,
    // расширение ключевых слов
    TOOLS_EXTENDED_KEYWORDS: 16,
    // подсветка топов
    TOOLS_CHECK_TOP: 17,
    // история выдачи SERP
    TOOLS_HISTORY_SERP: 18,
    // массовая проверка запросов
    TOOLS_KEYWORDS_BY_LIST: 19,
    // сравнение списков
    TOOLS_COMPARE: 20,
    // комбинатор ключевых фраз
    TOOLS_COMBINE: 21,
    // чистка неявных дублей
    TOOLS_DELETE_DOUBLE: 22,
    // выделение уникальных слов
    TOOLS_UNIQUE: 23,
    // сбор поисковых подсказок
    TOOLS_SUGGEST: 24,
    // онлайн парсинг Wordstat
    WORDSTAT: 25,
    // онлайн парсинг выдачи
    SERP: 26,
    // мониторинг позиций
    MONITORING: 27,

    // кластеризатор
    CLUSTERING: 28,

    // объявления в Яндекс Директе
    YANDEX_DIRECT: 29,
    // объявления в Яндекс Директе (архив)
    YANDEX_DIRECT_ARCHIVE: 39,
    // объявления в РСЯ
    RSYA: 30,

    // все отчёты и инструменты
    TOOLS: 31,

    // тарифы
    TARIFF: 32,

    // справочный центр
    HELP: 33,
    // документация API
    API: 34,
    // Блог
    BLOG: 35,
    // FAQ
    FAQ: 36,

    // Трекер ИИ
    AI_TRACKER: 38,
}
